import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { Storage } from '@ionic/storage';
import { environment } from 'src/environments/environment';
import { ConnectionService } from '../services/connection.service';
import { LoaderService } from '../services/loader.service';
import { StorageService } from '../services/storage.service';
import { ToastService } from '../services/toast.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss'],
})
export class MenuPage implements OnInit {

  sideMenuPageOptions = [
    {
      title : "Dashboard",
      pageLink: '/home/dashboard',
      iconName: 'home-outline'
    },
    {
      title : "My Profile",
      pageLink: '/home/profile',
      iconName: 'person-outline'
    },
    {
      title : "My Policies",
      pageLink: '/home/policies',
      iconName: 'document-text-outline'
    },
    // {
    //   title : "My Payments",
    //   pageLink: '/home/payments',
    //   iconName: 'card-outline'
    // },
    {
      title : "Claims",
      pageLink: '/home/claims',
      iconName: 'umbrella-outline'
    },    
    {
      title : "Settings",
      pageLink: '/home/settings',
      iconName: 'settings-outline'
    },    
    {
      title : "Support",
      pageLink: '/home/help',
      // iconName: 'help-circle-outline'
      iconName: 'chatbubbles-outline'
    },    
  ]

  tabMenuOptions = [
    {
      title : "Dashboard",
      pageLink: '/mainpage',
      iconName: 'pie-chart-outline'
    },
    {
      title : "My Policies",
      pageLink: '/',
      iconName: 'bar-chart-outline'
    },
    {
      title : "Policy Types",
      pageLink: '/',
      iconName: 'trending-up-outline'
    },
    {
      title : "My Insurance",
      pageLink: '/',
      iconName: 'umbrella-outline'
    },    
  ]

  selectedPath = ''; 
  userdetails:any;
  public _url: string = environment.baseUrl;
  imageSrc: any;

  constructor(
    private storage: Storage,
    private router: Router,
    private strg: StorageService,
    private toast: ToastService,
    private _loader: LoaderService,
    private apiService: ConnectionService
  ) { 
    this.router.events.subscribe((event: RouterEvent) => {
      if(event && event.url){
        this.selectedPath = event.url
      }
    });   
      this.strg.getStoreData("userObj").then(res=>{
        this.userdetails = res;   
        console.log('aaaaaaaaaaaa', this.userdetails);
        this.getProfileImage();
      })   
  }

  ngOnInit() {
    setTimeout(()=>{ console.log('userdata details', this.userdetails);},1000);
    
  }

  logout() {
    console.log("Logged Out");
  }

  getProfileImage() {
    this.imageSrc = this._url + '/user/public/profile-image/' + this.userdetails.email;
    console.log("Image source", this.imageSrc);
  }

  readURL(files: Event): void {
    if (files && files[0]) {
      const file = files[0];
      const reader = new FileReader();

      reader.onload = e => {
        this.imageSrc = reader.result;
        console.log("Reader result", reader.result);
      }

      reader.readAsDataURL(file);
      console.log("File value in file upload", file);
      console.log("File reader", reader);
      this.saveProfilePicture(file);
    }
  }

  saveProfilePicture(file) {
    let email = this.userdetails.email;
    let data = {
      profileImage: file,
      // email: email //for direct ref
    };
    console.log("datattttatattaa", data)
    this._loader.showLoader();
    this.apiService.updateProfilePic(data).subscribe(res => {
      console.log(res, "res of profile pic post");
      if (res instanceof HttpResponse) {
        let responseObj = JSON.parse(res.body);
        console.log("Response is of type HttpResponse and value of res.body = ", responseObj);
        if (responseObj.status == "OK") {
          this.toast.showToast("Upload Successfull");
        }
      }
      this._loader.hideLoader();
    }, err => {
      this._loader.hideLoader();
      // this.imageSrc = "";
      this.getProfileImage();
      this.toast.showToast("Error in pic upload", err);
      console.log("Error in pic upload", err);
    });
  }
}
